// src/components/GatewayDashboard.js
import React, { useState, useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { getSensors } from '../utils/firebase.utils';
import SensorDashboard from './SensorDashboard';

const GatewayDashboard = ({ gateway }) => {
  const [sensors, setSensors] = useState([]);

  useEffect(() => {
    const fetchSensors = async () => {
      const sensorsList = await getSensors();
      const gatewaySensors = sensorsList.filter(sensor => sensor.gatewayId === gateway.id);
      setSensors(gatewaySensors);
    };
    fetchSensors();
  }, [gateway]);

  return (
    <Box>
      <Text fontSize="xl" mb={4}>Sensors for {gateway.name}</Text>
      {sensors.map(sensor => (
        <Box key={sensor.id} mb={8}>
          <SensorDashboard sensor={sensor} />
        </Box>
      ))}
    </Box>
  );
};

export default GatewayDashboard;